import { Component, OnInit } from "@angular/core";
import {
    ITCIApplication, ITCIUserInfo,
    TCITenantSelectorType
} from "@tci/common";

import { BaseAppDetailMenuComponentInput, BaseAppDetailMenuComponentOutput } from "../../ng-app-details-menu";
import { AbstractTCITenantComponent } from "../../../ng-tenant/tci-tenant-component";

@Component({
    selector: TCITenantSelectorType.TCI_APP_DETAIL_ALERT.toString(),
    templateUrl: "./base-app-detail-alert.component.html",
    styleUrls: ["./base-app-detail-alert.component.less"]
})
export class BaseAppDetailAlertComponent<E, I extends BaseAppDetailMenuComponentInput, O extends BaseAppDetailMenuComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O> implements OnInit {

    appId: string;
    routeId: string;
    application: ITCIApplication;
    constructor() {
        super();
    }

    ngOnInit(): void {
        this.appId = this.input.application.id;
        this.routeId = this.input.componentOption.getRouteId();
        this.application = this.input.getApplication();
    }
}
